import React, { FC } from 'react';

const ExchangeIcon: FC<{ color?: string }> = ({ color }) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path
      d="M13.3333 2.5L16.6666 5.83333L13.3333 9.16667"
      stroke={color || '#444444'}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5 5.83334H16.6667"
      stroke={color || '#444444'}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.66659 17.5L3.33325 14.1667L6.66659 10.8333"
      stroke={color || '#444444'}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.9999 14.1667H3.33325"
      stroke={color || '#444444'}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ExchangeIcon;
